// extracted by mini-css-extract-plugin
export var label = "_d5-5";
export var slideContainer = "_d5-0";
export var slider = "_d5-1";
export var sliderLg = "_d5-4";
export var sliderMd = "_d5-3";
export var sliderSm = "_d5-2";